import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Timestamp } from "firebase/firestore";
import cld from "../../cloudinary";
import cancel from "../../images/cancel.svg";
import lens from "../../images/lens.svg";
import view from "../../images/view.svg";
import threeDots from "../../images/three-dots.svg";
import prev from "../../images/prev.svg";
import next from "../../images/next.svg";
import tranding from "../../images/tranding.svg";
import trade from "../../images/trade.svg";
import watch from "../../images/watch.svg";
import bid from "../../images/bid.svg";
import styles from "./ImageDetail.module.css";
import PriceHistoryBottomSection from "./PriceHistoryBottomSection";
import AboutBottomSection from "./AboutBottomSection";
import DiscriptionBottomSection from "./DiscriptionBottomSection";
import DetailsBottomSection from "./DetailsBottomSection";
import CollectionBottomSection from "./CollectionBottomSection";
import TrandingBottomSection from "./TrandingBottomSection";
import PropertiesBottomSection from "./PropertiesBottomSection";
import {
  hideBannerModal,
  setAboutImageDetailsToggle,
  updateActiveImage,
  startBidding,
} from "../../store/actions";
import { TagSvg, DiscriptionSvg, DetailsSvg, AboutSvg } from "../Common";
import { checkCookie } from "../Common";
import db from "../../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";

export default function ImageDetail() {
  const dispatch = useDispatch();
  const activeCelebData = useSelector((state) => state.activeCelebData);
  const activeImage = useSelector((state) => state.activeImage);
  const activeCelebId = useSelector((state) => state.activeCelebId);
  const aboutImageDetailsToggle = useSelector(
    (state) => state.aboutImageDetailsToggle
  );

  const [details, setDetails] = useState(undefined);

  const [apiData, setApiData] = useState([]);

  useEffect(() => {
    async function getDetails() {
      const q = query(
        collection(db, `biddify/${activeCelebId}/gallery`),
        where("id", "==", activeCelebData[activeImage].id)
      );
      const collectionn = await getDocs(q);
      const data = collectionn.docs[0].data().details;
      if (data === undefined) {
        setDetails(undefined);
      } else {
        setDetails(data);
      }
    }
    getDetails();

    async function getApiData() {
      fetch(
        "https://api.etherscan.io/api?_limit=10&action=txlist&module=account&address=0x7Be8076f4EA4A4AD08075C2508e481d6C946D12b&sort=desc&apikey=ZNDTMCZJF5PX163JFXE5PX4VVYTI8DBIGU"
      )
        .then((res) => res.json())
        .then((res) => {
          console.log(res.result.slice(0, 10));
          setApiData(res.result.slice(0, 10));
        });
    }
    getApiData();
  }, [activeImage]);

  return (
    <div className={`${styles.fullWidthImageContainer}`}>
      <div className="container-fluid">
        <div className="row py-3 py-md-0">
          <div className="col-md-5 pt-md-3 px-md-4">
            <div className="row">
              <img
                src={cld.image(activeCelebData[activeImage].public_id).toURL()}
                className={styles.mainImg}
                alt="Celebrity"
              />
              <BottomToggleBar
                dispatch={dispatch}
                aboutImageDetailsToggle={aboutImageDetailsToggle}
              />
            </div>
          </div>
          <RightSide
            details={details}
            activeCelebData={activeCelebData}
            dispatch={dispatch}
            activeImage={activeImage}
            aboutImageDetailsToggle={aboutImageDetailsToggle}
          />
          <BottomToggleSection
            details={details}
            aboutImageDetailsToggle={aboutImageDetailsToggle}
            apiData={apiData}
          />
        </div>
      </div>
    </div>
  );
}

const BottomToggleBar = ({ dispatch, aboutImageDetailsToggle }) => (
  <div className={styles.imageBottomIcons}>
    {["Properties", "Description", "Details", "About"].map((item, index) => (
      <div
        onClick={() => dispatch(setAboutImageDetailsToggle(index + 1))}
        className={`${
          aboutImageDetailsToggle === index + 1
            ? styles.imageBottomIconsDivActive
            : null
        } ${styles.imageBottomIconsDiv} cursor-pointer`}
        key={index}
      >
        {item === "Properties" ? (
          <TagSvg
            color={aboutImageDetailsToggle === 1 ? "#e0054e" : "#fff"}
            size="28px"
          />
        ) : item === "Description" ? (
          <DiscriptionSvg
            color={aboutImageDetailsToggle === 2 ? "#e0054e" : "#fff"}
            size="28px"
          />
        ) : item === "Details" ? (
          <DetailsSvg
            color={aboutImageDetailsToggle === 3 ? "#e0054e" : "#fff"}
            size="28px"
          />
        ) : item === "About" ? (
          <AboutSvg
            color={aboutImageDetailsToggle === 4 ? "#e0054e" : "#fff"}
            size="28px"
          />
        ) : null}
        <p
          className={`${
            aboutImageDetailsToggle === index + 1
              ? styles.imageBottomIconsDivActiveP
              : null
          } ${styles.imageBottomIconsDivP}
            `}
        >
          {item}
        </p>
      </div>
    ))}
  </div>
);

const BottomToggleSection = ({ details, aboutImageDetailsToggle, apiData }) => {
  return aboutImageDetailsToggle > 0 && aboutImageDetailsToggle < 6 ? (
    <div className="col-md-5 px-md-4">
      <div
        className={`${
          aboutImageDetailsToggle === 1
            ? styles.detailsBoxRadiusStart
            : aboutImageDetailsToggle === 5
            ? styles.detailsBoxRadiusEnd
            : styles.detailsBoxRadiusCenter
        } ${styles.detailsBox}`}
      >
        {aboutImageDetailsToggle === 1 ? (
          <PropertiesBottomSection details={details} />
        ) : aboutImageDetailsToggle === 2 ? (
          <DiscriptionBottomSection details={details} />
        ) : aboutImageDetailsToggle === 3 ? (
          <DetailsBottomSection details={details} />
        ) : aboutImageDetailsToggle === 4 ? (
          <AboutBottomSection details={details} />
        ) : null}
      </div>
    </div>
  ) : aboutImageDetailsToggle > 5 && aboutImageDetailsToggle < 8 ? (
    <div className="col-12">
      <div className={`${styles.detailsBox} ${styles.detailsBoxRadiusCenter}`}>
        {aboutImageDetailsToggle === 6 ? (
          <TrandingBottomSection apiData={apiData} />
        ) : aboutImageDetailsToggle === 7 ? (
          <PriceHistoryBottomSection apiData={apiData} />
        ) : null}
      </div>
    </div>
  ) : null;
};

const RightSide = ({
  details,
  activeCelebData,
  dispatch,
  aboutImageDetailsToggle,
  activeImage,
}) => {
  const activeCelebId = useSelector((state) => state.activeCelebId);
  const loggedUser = useSelector((state) => state.loggedUser);

  const bidFn = () => {
    if (!checkCookie("active_user")) {
      alert("Login first!");
      return;
    }
    dispatch(
      startBidding({
        userId: loggedUser.uid,
        imageId: activeCelebData[activeImage].id,
        celebId: activeCelebId,
      })
    );
  };

  return (
    <div className="col-md-7 pt-md-3 ps-md-3 pe-md-5">
      <div className={styles.rightIconsBar}>
        <img
          src={threeDots}
          alt="Three Dots Icon"
          className={`${styles.rightIconsBarImg}`}
        />
        {/* <img
          src={lens}
          alt="Len Icon"
          className={`${styles.rightIconsBarImg}`}
        /> */}
        <img
          src={prev}
          alt="Previous Icon"
          className={`${styles.rightIconsBarImg} `}
          onClick={() => {
            if (activeImage > 0) {
              dispatch(updateActiveImage(activeImage - 1));
            }
          }}
        />
        <img
          src={next}
          alt="Next Icon"
          className={`${styles.rightIconsBarImg}`}
          onClick={() => {
            if (activeImage < activeCelebData.length - 1) {
              dispatch(updateActiveImage(activeImage + 1));
            }
          }}
        />
        <img
          src={cancel}
          className={`${styles.rightIconsBarImg} banner-exclude`}
          onClick={() => {
            dispatch(hideBannerModal());
            dispatch(setAboutImageDetailsToggle(1));
          }}
          alt="Cancel Icon"
        />
      </div>
      <div className={styles.rightBoldText}>
        #{details ? details.title : ""}
      </div>
      <div className={styles.rightStatsText}>
        Owner:{" "}
        <span className={styles.rightStatsTextSpan}>
          {details ? details.created_by : ""}
        </span>{" "}
        <img src={view} alt="Views Icon" className={styles.rightStatsTextImg} />{" "}
        {details ? details.views : ""} views
      </div>
      <div className={styles.rightDescription}>
        <div className="text-end mb-5">
          <p className={styles.rightDescriptionPara}>Highest Bid</p>
          <h2 className={styles.rightDescriptionH2}>
            ${activeCelebData[activeImage].highestBid}
          </h2>
          <p className={styles.rightDescriptionPara}>
            <img
              src={watch}
              alt="Watch Icon"
              className={`${styles.rightDescriptionImg} ${styles.rightDescriptionParaImg}`}
            />
            <RemainTime time={activeCelebData[activeImage].timeLeft.seconds} />
          </p>
          <button className={styles.rightDescriptionButton} onClick={bidFn}>
            BUY NOW{" "}
            <img
              src={bid}
              alt="Buy Icon"
              className={styles.rightDescriptionImg}
            />
          </button>
        </div>
        <div>
          <span
            onClick={() => dispatch(setAboutImageDetailsToggle(6))}
            className={`${
              aboutImageDetailsToggle === 6
                ? styles.rightDescriptionSpanActive
                : null
            } ${styles.rightDescriptionSpan} cursor-pointer`}
          >
            <img
              src={tranding}
              alt="Tranding Icon"
              className={styles.rightDescriptionImg}
            />
            Trading History
          </span>
          <span
            onClick={() => dispatch(setAboutImageDetailsToggle(7))}
            className={`${
              aboutImageDetailsToggle === 7
                ? styles.rightDescriptionSpanActive
                : null
            } ${styles.rightDescriptionSpan} cursor-pointer`}
          >
            <img
              src={trade}
              alt="Trade Icon"
              className={styles.rightDescriptionImg}
            />{" "}
            Price History
          </span>
        </div>
      </div>
    </div>
  );
};

const RemainTime = ({ time }) => {
  const [liveTime, setLiveTime] = useState(0);

  function timeFormat(seconds) {
    var secondss = parseInt(seconds);
    var days = Math.floor(secondss / (3600 * 24));
    secondss -= days * 3600 * 24;
    var hrs = Math.floor(secondss / 3600);
    secondss -= hrs * 3600;
    var mnts = Math.floor(secondss / 60);
    secondss -= mnts * 60;
    return days + ":" + hrs + ":" + mnts + ":" + secondss;
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setLiveTime(
        time - Timestamp.fromDate(new Date()).seconds > 0
          ? time - Timestamp.fromDate(new Date()).seconds
          : 0
      );
    }, 1000);
    return () => clearInterval(interval);
  }, [time]);

  return timeFormat(liveTime) + " Left";
};
